module.exports = __webpack_public_path__ + "img/orange-pencil-icon.672b11e4.svg";